import { render, staticRenderFns } from "./complianceDialog.vue?vue&type=template&id=9538060a&scoped=true"
import script from "./complianceDialog.vue?vue&type=script&lang=js"
export * from "./complianceDialog.vue?vue&type=script&lang=js"
import style0 from "./complianceDialog.vue?vue&type=style&index=0&id=9538060a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9538060a",
  null
  
)

export default component.exports